import { workspaceSignedOut } from '../data/workspace'
import { indexedDbAuthStorage, nativeOAuthAttemptStorage } from '../supabase/authStorage'
import { AUTH_STORAGE_PREFIX } from '../utils/storageNames'
import type { SupabaseConfig } from '../supabase/config'
import type { AuthSession } from './authProvider'
import { parseStoredSession, toAuthSession } from '../neon/session'

let initialIdentity: AuthSession | null = null
export function setInitialIdentity(session: AuthSession | null): void { initialIdentity = session }
export function getInitialIdentity(): AuthSession | null { return initialIdentity }

/** Local continuity, never server authorization. Expiry alone does not erase offline access. */
export async function readCachedIdentity(config: SupabaseConfig): Promise<AuthSession | null> {
  const raw = await indexedDbAuthStorage.getItem(`${AUTH_STORAGE_PREFIX}-${config.environment}`)
  if (!raw) return null
  if (config.backend === 'neon') {
    const stored = parseStoredSession(raw)
    return stored ? toAuthSession(stored) : null
  }
  const value = JSON.parse(raw)
  if (typeof value?.user?.id !== 'string' || !value.user.id || typeof value.access_token !== 'string') return null
  return {
    user: { id: value.user.id, email: value.user.email ?? null, name: value.user.user_metadata?.full_name ?? value.user.email ?? 'miniMany user', avatarUrl: null },
    expiresAt: typeof value.expires_at === 'number' ? value.expires_at * 1000 : null,
  }
}

export async function clearLocalAuthentication(config: SupabaseConfig): Promise<void> {
  const scope = { project: config.url, environment: config.environment }
  if (!workspaceSignedOut(scope)) return
  const attempt = await nativeOAuthAttemptStorage.read()
  const key = `${AUTH_STORAGE_PREFIX}-${config.environment}`
  await indexedDbAuthStorage.removeItem(key)
  if (!workspaceSignedOut(scope)) return
  await indexedDbAuthStorage.removeItem(`${key}-code-verifier`)
  if (attempt && workspaceSignedOut(scope)) await nativeOAuthAttemptStorage.clear(attempt.id)
}
